import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getSiteKey } from './RecaptchaProvider.utils';
export function useRecaptcha() {
  var _useGoogleReCaptcha = useGoogleReCaptcha(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var siteKey = getSiteKey();
  var siteKeyAvailable = !!siteKey;

  var getToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (siteKeyAvailable) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              if (loaded) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", null);

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return executeRecaptcha(action);

            case 7:
              return _context.abrupt("return", _context.sent);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](4); // eslint-disable-next-line no-console

              console.error(_context.t0);
              return _context.abrupt("return", null);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 10]]);
    }));

    return function getToken(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (!siteKeyAvailable) {
      setLoaded(true);
    } else {
      setLoaded(!!executeRecaptcha);
    }
  }, [executeRecaptcha]);
  return [getToken, loaded];
}